var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Edit",
    d: "M84.463,8.653l1.529-1.529h0a.438.438,0,0,0,0-.619L83.733,4.247a.437.437,0,0,0-.618,0L81.586,5.776Zm-3.9-1.85L70.12,17.246v2.7h0a.175.175,0,0,0,.175.175H73L83.436,9.681Z",
    transform: "translate(-70.12 -4.119)",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditplan);
export default __webpack_public_path__ + "static/media/editplan.49caa24ba263cf2127302d529a55a6fe.svg";
export { ForwardRef as ReactComponent };